import React from 'react';
import './Footer.css';

function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-gradient-line" />
      <div className="container">
        <div className="footer-content">
          <div className="footer-section footer-brand">
            <h3>
              <span className="footer-bracket">&lt;</span>
              GS
              <span className="footer-bracket"> /&gt;</span>
            </h3>
            <p>Full Stack Software Engineer building cloud-native solutions and AI-powered applications.</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#home">Home</a></li>
              <li><a href="#about">About</a></li>
              <li><a href="#skills">Skills</a></li>
              <li><a href="#projects">Projects</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>
          
          <div className="footer-section">
            <h4>Connect</h4>
            <ul>
              <li><a href="https://github.com/gowthams007" target="_blank" rel="noopener noreferrer">GitHub</a></li>
              <li><a href="https://linkedin.com/in/gowtham-s-336062199" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
              <li><a href="mailto:gowtham11101998@gmail.com">Email</a></li>
            </ul>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>&copy; {currentYear} Gowtham S. All rights reserved.</p>
          <p>
            Designed & Built with 
            <span className="heart" role="img" aria-label="love"> ❤️ </span>
            using React
          </p>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
